import React, { useEffect, useState } from 'react';
import { Layout, Menu, Typography, Button } from 'antd';
import {
  UnorderedListOutlined,
  DashboardOutlined,
  HomeOutlined,
  LogoutOutlined,
  CrownOutlined
} from '@ant-design/icons';
import { logout } from '../utils/jwt';
import { handleWebSocketData } from '../utils/websocketHandler';
import { useNavigate } from 'react-router-dom';
import PlaceholderImage from '../assets/logo.png';
import './Dashboard.css';
import Admin from '../components/Admin';
import Overview from '../components/Overview';
import InDepth from '../components/InDepth';
import simulateData from '../utils/dataSimulator'; // Import the simulator


const { Header, Sider, Content } = Layout;
const { Title } = Typography;

const Dashboard = () => {
  const [data, setData] = useState({});
  const [error, setError] = useState(null);
  const [currentView, setCurrentView] = useState('overview');
  const [isAdmin, setIsAdmin] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {

    document.documentElement.classList.add('dashboard');
    document.body.classList.add('dashboard');

    // Use the simulator to update the data state
    simulateData(setData);

    const ws = new WebSocket(process.env.REACT_APP_WEBSOCKET_URL);

ws.onopen = () => {
    console.log('WebSocket connection established');
  };

  ws.onmessage = (event) => {
    console.log('WebSocket message received:', event.data);
    handleWebSocketData(event.data, setData);
  };

  ws.onclose = (event) => {
    console.log('WebSocket connection closed', event);
    if (!event.wasClean) {
      setError('WebSocket connection closed unexpectedly.');
    }
  };

  ws.onerror = (error) => {
    console.error('WebSocket error:', error);
    setError('WebSocket connection error.');
  };

  return () => {
    ws.close();
  };
  }, []);

  useEffect(() => {
    const checkAdminStatus = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/check-admin`, {
          credentials: 'include',
        });
        if (response.ok) {
          setIsAdmin(true);
        } else {
          setIsAdmin(false);
        }
      } catch (error) {
        console.error('Error checking admin status:', error);
        setIsAdmin(false);
      }
    };

    checkAdminStatus();
  }, []);

  const handleLogout = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/logout`, {
        method: 'POST',
        credentials: 'include',
      });
  
      if (response.ok) {
        logout();
        navigate('/login');
      } else {
        console.error('Logout failed');
      }
    } catch (error) {
      console.error('Error during logout:', error);
    }
  };

  const renderContent = () => {
    switch (currentView) {
      case 'overview':
        return <Overview data={data} />;
      case 'dashboard':
        return <InDepth data={data}/>;
      case 'admin':
        return <Admin />;
      default:
        return null;
    }
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider collapsed theme="dark" className="custom-sider">
        <img src={PlaceholderImage} alt="MSU SRT Logo" className="w-full h-auto" />
        <Menu theme="dark" defaultSelectedKeys={['1']} mode="inline" className="custom-menu">
          <Menu.Item key="1" icon={<DashboardOutlined />} onClick={() => setCurrentView('overview')}>
            Overview
          </Menu.Item>
          <Menu.Item key="2" icon={<UnorderedListOutlined />} onClick={() => setCurrentView('dashboard')}>
            In-Depth
          </Menu.Item>
          {isAdmin && (
            <Menu.Item key="3" icon={<CrownOutlined />} onClick={() => setCurrentView('admin')}>
              Admin
            </Menu.Item>
          )}
          <Menu.Divider />
          <Menu.Item key="6" icon={<LogoutOutlined />} onClick={handleLogout} className='logout-menu-item' style={{ position: 'absolute', bottom: 0 }}>
            Logout
          </Menu.Item>
        </Menu>
      </Sider>
      <Layout style={{background: '#121212'}}>
        <Header className="site-layout-background" style={{ padding: 0 }}>
          <div className="header-content">
            <Button type="link" icon={<HomeOutlined />} className="text-2xl" onClick={() => navigate('/')}></Button>
          </div>
        </Header>
        <Content style={{ margin: '16px' }}>
            {renderContent()}
        </Content>
      </Layout>
    </Layout>
  );
};

export default Dashboard;
